import { useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import "./superAdmin.css"
import SuperAdminNavbar from '../Navbar/SuperAdminNavbar';
import { AppContext } from '../ContextApi/ContextApi';
import Footer from '../Usables/Footer';
import NotificationPanel from '../Usables/NotificationPanel';
import axios from 'axios';
import { toast } from 'react-toastify';
import {NotificationIconButton} from '../Usables/Buttons';
import Swal from 'sweetalert2';
import { basePath} from '../Constants/constant';
import AutoLogout from '../LoginSignup/AutoLogout';

function SuperAdmin(props) {
    const {setAdminNavbar, apiHeaderJSON, notifications, getNotifications }=useContext(AppContext);
    const [showNotifications, setShowNotifications] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const handleClick = async (val) => {
         
        let requestData = {
            notification_id: val?.notification_id  
        };

        let config = {
            headers: apiHeaderJSON,
        };

        try {
            const response = await axios.post(`${basePath}/MarkNotificationRead`, requestData, config);
            // console.log("/job - response", response);
            if (response.status === 200) {
                getNotifications();
                toast.success(response.data?.message || "Notification read Successfully");
            } else {
                toast.error(response.data?.message || "Unable to update notification status.");
            }
            setLoading(false);
        } catch (error) {
            if (error.response) {
                console.error("notification status update Response error:", error.response.status, error.response.data);
                toast.error(error.response.data?.message || "Unable to update notification status.");
            } else {
                // Network or other error
                console.error("Request error:", error.message);
                toast.error("Network or unexpected error occurred.");
            }
            setLoading(false);
        }
        
    }

    return (
        <main onClick={()=>{setAdminNavbar(false);}} className=' lightBabyGreen flex w-full h-screen overflow-hidden homeStructure'>
            <AutoLogout/>
            <aside className=' h-fit'>
                <SuperAdminNavbar />
            </aside>
            <section className=' w-full flex flex-col flex-grow-1 justify-between items-center baseHeightWidth mt-4 pl-3 pr-4 pb-1  overflow-y-scroll '>
                {["Recruiter", "Team Lead"].includes(localStorage.getItem("role")) ? null : (
                    <>
                        <div className="fixed top-4 right-4 z-[11]">
                        <NotificationIconButton
                            tooltipName="Notifications"
                            position="bottom"
                            onClick={() => setShowNotifications((prev) => !prev)}
                            notify= {notifications.filter(val=> val.message_status == 1).length ? true : false}
                        />
                        </div>
                        {/* Notification Panel */}
                        <NotificationPanel
                        show={showNotifications}
                        onClose={() => setShowNotifications(false)}
                        notifications={notifications}
                        handleClick={handleClick}
                        loading={loading}
                        />
                    </>
                )}

                <div className='flex-1 w-full'>
                    <Outlet/>
                </div>
                <Footer/>
            </section>
        </main>
    );
}

export default SuperAdmin;